module.exports = __webpack_public_path__ + "static/media/trash-alt.adfe7127.svg";